import styled from 'styled-components';

import {
  colorGrey100,
  fontFamilyPrimary,
  mediaQueryTabletMin,
} from '@/styleUtils';

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-bottom: 1px solid ${colorGrey100};
  padding: 12px 0;

  &:last-child {
    border-bottom: 1px solid transparent;
  }

  @media ${mediaQueryTabletMin} {
    flex-direction: row;
    gap: 40px;
  }
`;

export const Td = styled.td`
  width: 100%;
  padding: 0;
  font: 400 14px/24px ${fontFamilyPrimary};

  &:first-child {
    font-weight: 700;
  }

  ul {
    list-style-type: disc;
    padding-left: 12px;
  }
`;
